import React, { Fragment } from "react";
import { Input, Label } from "reactstrap";
import { VARIATION_SWITCH_LIST_2 } from "../../../../Data/FormWidgets";
import { LI, P } from "../../../../AbstractElements";

export const VariationOfSwitcheTwo = () => {
  return (
    <>
      {VARIATION_SWITCH_LIST_2.map(({ flexClass, text, color }, index) => (
        <Fragment key={index}>
          <LI className="tg-list-item">
            <div className="d-flex">
              <div className={`flex-grow-1 text-end ${flexClass}`}>
                <Label className="switch mb-0 square-checked">
                  <Input type="checkbox" defaultChecked />
                  <span className={`switch-state bg-${color} rounded-2`}></span>
                </Label>
              </div>
            </div>
          </LI>
          <LI>
            <P>{text}</P>
          </LI>
        </Fragment>
      ))}
    </>
  );
};
